/**
 * 待办接口（成队后由后端自动生成，前端只读取与改状态）。
 * 契约：GET /me/tasks → {tasks[]}；GET /projects/:id/tasks → {tasks[]}；PATCH /tasks/:id → {task}
 */
import { api } from './client.js';
import type { TaskPatch, TasksDto } from './types.js';

export const tasksApi = {
  /** 我负责或我所在队伍的待办（Tasks 看板默认数据源） */
  listMine: (): Promise<TasksDto> => api.get<TasksDto>('/me/tasks'),

  /** 某个项目的待办（Team 页成队后按 projectId 查看） */
  listByProject: (projectId: string): Promise<TasksDto> =>
    api.get<TasksDto>(`/projects/${encodeURIComponent(projectId)}/tasks`),

  /** 改状态/负责人/截止时间 */
  update: (taskId: string, patch: TaskPatch): Promise<{ task: TasksDto['tasks'][number] }> =>
    api.patch<{ task: TasksDto['tasks'][number] }>(`/tasks/${encodeURIComponent(taskId)}`, patch),

  /** 指派/取消负责人（T69 起仅队长，后端 403 兜底） */
  assign: (taskId: string, ownerId: string | null): Promise<{ task: TasksDto['tasks'][number] }> =>
    tasksApi.update(taskId, { ownerId }),

  /** 改截止日期（YYYY-MM-DD 或 ISO；null 清除） */
  setDue: (taskId: string, dueDate: string | null): Promise<{ task: TasksDto['tasks'][number] }> =>
    tasksApi.update(taskId, { dueDate }),
};